import { provideEffects } from '@ngrx/effects';

import { OptionSheetViewEffects } from './option-sheet-view.effects';

export function provideOptionSheetView() {
    return [provideEffects([OptionSheetViewEffects])];
}
